import { cn } from "@/lib/utils"
import React from "react"

const Announcement = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            "group flex items-center gap-2 rounded-full border border-border bg-background px-1 py-1 pr-3 text-sm shadow-sm transition-colors hover:bg-muted/50",
            className
        )}
        {...props}
    />
))
Announcement.displayName = "Announcement"

const AnnouncementTag = React.forwardRef<
    HTMLSpanElement,
    React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
    <span
        ref={ref}
        className={cn(
            "inline-flex items-center rounded-full bg-sidebar-primary border px-2 py-0.5 text-xs font-semibold text-sidebar-primary-foreground transition-colors",
            className
        )}
        {...props}
    />
))
AnnouncementTag.displayName = "AnnouncementTag"

const AnnouncementTitle = React.forwardRef<
    HTMLSpanElement,
    React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
    <span
        ref={ref}
        className={cn("flex items-center gap-1 text-xs font-medium", className)}
        {...props}
    />
))
AnnouncementTitle.displayName = "AnnouncementTitle"

export { Announcement, AnnouncementTag, AnnouncementTitle }
